<fui-more-control [options]="data" [disabled]="readonly"
                  [labelField]="labelField"
                  [placeholder]="placeholder"
                  [icon]="icon"
                  [iconSize]="iconSize"
                  [label]="label"
                  [loading]="isLoading"
                  [(value)]="selectControlValues"
                  [valueField]="valueField"
                  (focussed$)="onFocus($event)">
</fui-more-control>
